module.exports = __webpack_public_path__ + "img/45_16.b32caf04.png";